'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from '@radix-ui/react-tabs';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useTabsContext } from './TabsContext';
const TabsList = forwardRef(({ className, ...props }, ref) => {
    const { variant } = useTabsContext();
    return (_jsx(List, { ref: ref, className: cn('inline-flex items-center justify-center', variant === 'underline' && 'border-y border-y-metal-100 dark:border-y-metal-800', className), ...props }));
});
TabsList.displayName = List.displayName;
export { TabsList };
